import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { responseArray, Paginate, responseObj } from '../nest-model/nest-model';

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LeaveSettingtApiProvider {

  module: string = 'leave';
  model: string = 'sfLeaveRequest';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello AccessManagementProvider Provider');
  }

  getTypeLeave(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "getTypeLeave";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  cekBeforeDelete(leaveCode: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "cekBeforeDelete";
    const params: any = { leaveCode: leaveCode };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  deleteSetting(leaveCode: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "deleteSetting";
    const params: any = { leaveCode: leaveCode };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  editSetting(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "editSetting";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  addSetting(formData: Object) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "addSetting";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  getAttendCode() {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getAttendCode";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/leave/leave-setting-api.ts